import { TokenStore } from "@/types/auth"
import { ReadonlyURLSearchParams } from "next/navigation"
import { match } from "ts-pattern"

export function handleRedirect({
   redirectUrl,
   tokens,
   callbackUrl,
   defaultRedirect,
}: {
   redirectUrl: string | null
   tokens: TokenStore
   callbackUrl: string | null
   defaultRedirect: string
}) {
   // If there's a callbackUrl, redirect to internal route
   if (callbackUrl) {
      const decodedCallback = decodeURIComponent(callbackUrl)

      return `${decodedCallback}`
   }

   // Otherwise, use the original subdomain logic
   const token = match(redirectUrl)
      .with("training", () => tokens.training_session)
      .with("jobs", () => tokens.jobs_session)
      .with("webinars", () => tokens.webinars_session)
      .otherwise(() => null)

   return token ? `https://${redirectUrl}.restaurantassociation.com?session=${token.token}` : defaultRedirect
}

export function redirectWithParams({ searchParams }: { searchParams: ReadonlyURLSearchParams }) {
   const params = new URLSearchParams(searchParams.toString())
   return `/?${params.toString()}`
}
